import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getTracksPopularLastWeek } from "../api/getTrack";
import Skeleton from "react-loading-skeleton";

class TracksPopularLastWeekContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || [];
    const { tracks, dates } = results;
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && tracks && tracks.length === 0) {
      return null;
    }
    return render({ tracks, dates, loading, failure });
  };
}

// TracksPopularLastWeekContainer.propTypes = {
//   trackId: PropTypes.string.isRequired
// };

export default CreateContainer(getTracksPopularLastWeek, TracksPopularLastWeekContainer);
